<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Campanha gripe"
            description="Público alvo a ser vacinado na campanha contra a gripe no ano atual"
            url="/imunizacao"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'Campanha gripe',
    titleTemplate: null,
  },
  data() {
    return {}
  },
}
</script>

<style></style>
